import { Component, OnInit } from '@angular/core';
import { DwRadioItem } from '../quiz-answer-true-false/quiz-answer-true-false.component';
import { QuizAnswerBaseComponent } from '../base/quiz-answer-base.component';
import { flattenArray, unflattenArray } from '@devwareapps/devware-cap';
import { QuestionAnswerEntity } from '../../../../../meta-data/app-meta-data.service';
import { ArrayUtilService } from '../../../../shared/util/array-util.service';
import { QuestionAnswerReview, QuestionAnswerReviews } from '../../../models/question-answer-review.model';
import { QuizUtilService } from '../../../services/quiz-util.service';

@Component({
  selector: 'app-quiz-answer-multiple-answer',
  template: `
  <label *ngFor="let answer of answersToShow; let i = index" class="quiz-option is-multi-select"
         [class.is-selected]="!reviewAnswers && checkValues[answer.QuestionAnswerId]"
         [class.is-correct]="(reviewAnswers || testMode) && answerReviews[i]?.textNote !== 'Incorrect' && !!answerReviews[i]"
         [class.is-incorrect]="(reviewAnswers || testMode) && answerReviews[i]?.textNote === 'Incorrect'"
         [class.is-disabled]="reviewAnswers">
    <input type="checkbox" class="quiz-option__input"
           [disabled]="reviewAnswers"
           [ngModel]="checkValues[answer.QuestionAnswerId]"
           (ngModelChange)="setAnswer($event, answer)" />
    <span class="quiz-option__chip" aria-hidden="true">{{letterFor(i)}}</span>
    <span class="quiz-option__text">
      {{answer.AnswerText}}
      <dw-html-view *ngIf="(reviewAnswers || testMode) && answerReviews[i]?.explanationText"
                    class="quiz-option__explanation"
                    [ngModel]="answerReviews[i].explanationText"></dw-html-view>
    </span>

    <span *ngIf="answerReviews[i] && (testMode || reviewAnswers)" class="quiz-option__review">
      <i class="quiz-option__review-icon" [ngClass]="answerReviews[i].iconClass" aria-hidden="true"></i>
      <span class="quiz-option__review-note">{{answerReviews[i].textNote}}</span>
      <button type="button" class="quiz-option__sparkle" *ngIf="answerReviews[i].aiExplanationHtml"
              (click)="setAiDetail(answerReviews[i].aiExplanationHtml); $event.preventDefault(); $event.stopPropagation();"
              title="AI Explanation">
        <i class="fa fa-sparkles" aria-hidden="true"></i>
        <span>Explain</span>
      </button>
    </span>
  </label>

  <div *ngIf="currentAiExplanationHtml" class="answer-explanation-ai">
    <span class="answer-explanation-ai-header"><i class="fa fa-sparkles dw-purple" aria-hidden="true"></i> Explanation:</span>
    <dw-html-view [ngModel]="currentAiExplanationHtml"></dw-html-view>
  </div>
  `
})
export class QuizAnswerMultipleAnswerComponent extends QuizAnswerBaseComponent {
  options: DwRadioItem[] = [];
  checkValues: { [prop: string]: number } = {};

  answersToShow: QuestionAnswerEntity[] = [];

  answerReviews: QuestionAnswerReviews = {};

  selectedOption: any;
  currentAiExplanationHtml: string = '';
  constructor(private arrayUtilService: ArrayUtilService, private quizUtilService: QuizUtilService) {
    super();
  }

  ngOnInit(): void {

  }

  setAnswer(value, answer: QuestionAnswerEntity) {
    if (value) {
      this.checkValues[answer.QuestionAnswerId] = answer.QuestionAnswerId;
    } else {
      delete this.checkValues[answer.QuestionAnswerId];
    }

    this.questionAnswerValue.quizQuestionAnswerIds = unflattenArray(this.checkValues);

    this.setAnswerValue(this.questionAnswerValue, this.questionAnswerValue.quizQuestionAnswerIds.length > 0);
  
    this.currentAiExplanationHtml = '';

    if (this.testMode) {
      this.setupAnswerReviews();
    }
  }

  setAiDetail(aiExplanationHtml: string) {
    this.currentAiExplanationHtml = aiExplanationHtml;
  }

  setupAnswer() {
    this.answerReviews = {};
    this.currentAiExplanationHtml = '';

    this.questionAnswerValue.quizQuestionAnswerIds = this.questionAnswerValue.quizQuestionAnswerIds || [];

    this.checkValues = flattenArray(this.questionAnswerValue.quizQuestionAnswerIds);

    // Set answers to use default order
    this.answersToShow = [...this.question.QuestionAnswer];

    if (this.questionAnswerValue.answerOrder) {
      this.answersToShow = this.answersToShow.sort((a, b) => {
        return this.questionAnswerValue.answerOrder.indexOf(a.QuestionAnswerId) - this.questionAnswerValue.answerOrder.indexOf(b.QuestionAnswerId);
      });

      if (this.reviewAnswers || this.testMode) {
        this.setupAnswerReviews();
      }
      return;
    }

    // Setup new order
    if (this.question.UseRandomOrder) {
      this.answersToShow = this.arrayUtilService.shuffle(this.answersToShow);
    }

    // Set the answer order so when we view it later, it will be in the same order
    this.questionAnswerValue.answerOrder = this.answersToShow.map((answer) => answer.QuestionAnswerId);
    this.persistAnswerValue(this.questionAnswerValue);

    if (this.reviewAnswers || this.testMode) {
      this.setupAnswerReviews();
    }
  }

  setupAnswerReviews() {
    this.answerReviews = this.quizUtilService.getAnswerReviews(this.questionLink, this.questionResult, this.questionAnswerValue, this.answersToShow, this.testMode);
    const selectedReview = this.answersToShow
      .map((answer, index) => this.checkValues[answer.QuestionAnswerId] ? this.answerReviews[index] : null)
      .find(review => !!review?.aiExplanationHtml);
    this.currentAiExplanationHtml = selectedReview?.aiExplanationHtml || '';
  }

}
